<template>
    <div>
        <button
            v-if="!editing"
            v-t="'Objekte zum Löschen auswählen'"
            class="kgr-button kgr-button--link"
            @click="showSelectors()"
        >
        </button>
        <template v-if="editing">
            <div>
                <div class="kgr-inputGroup">
                    <kgr-button
                        v-t="allSelected ? 'batchDeleteButtons.button.deselectAll' : 'Alle auswählen'"
                        type="link"
                        @click="allSelected ? deselectAll() : selectAll()"
                    />
                    <kgr-button
                        v-t="'Ausgewählte Objekte Löschen'"
                        type="red"
                        @click="getSelectedIds().length > 0 ? showConfirmation = true : showSelectionEmpty = true;"
                    />
                    <kgr-icon-close
                        small
                        :title="$t('Aktion abbrechen')"
                        style="vertical-align: middle"
                        @click="cancel()"
                    />
                </div>
            </div>
        </template>
        <kgr-generic-modal
            :value="showSelectionEmpty"
            :headline="$t('Keine Objekte ausgewählt')"
            @close="showSelectionEmpty = false"
        >
            {{ $t('Sie haben keine Objekte zum Löschen ausgewählt.') }}
            <template #footer>
                <kgr-button
                    @click="showSelectionEmpty = false"
                >
                    {{ $t('ok.ok') }}
                </kgr-button>
            </template>
        </kgr-generic-modal>
        <kgr-generic-modal
            :value="showConfirmation"
            :headline="headline"
            @post-input="onInput"
            @close="cancel()"
        >
            {{ $t('Sollen die markierten Objekte ({count}) wirklich unwiderruflich gelöscht werden?', { count: getSelectedIds().length }) }}
            <template #footer>
                <kgr-button
                    type="red"
                    @click="deleteSelected()"
                >
                    {{ $t('delete') }}
                </kgr-button>
                <kgr-button
                    type="grey"
                    @click="cancel()"
                >
                    {{ $t('cancel') }}
                </kgr-button>
            </template>
        </kgr-generic-modal>
        <slot></slot>
    </div>
</template>

<script>
import Button from '../common/form/button/KgrButton.vue';
import GenericModal from '../common/modal/GenericModal.vue';
import IconClose from '../common/icon/IconClose.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-generic-modal': GenericModal,
        'kgr-button': Button,
        'kgr-icon-close': IconClose,
    },
    props: {
        selectorClass: {
            type: String,
            required: true,
        },
        deletePath: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showConfirmation: false,
            showSelectionEmpty: false,
            elements: [],
            editing: false,
            allSelected: false,
        };
    },
    computed: {
        headline() {
            return this.$t('delete');
        },
        selectedIds() {
            return this.elements.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
        },
    },
    methods: {
        cancel() {
            this.showConfirmation = false;
            this.hideSelectors();
        },
        showSelectors() {
            this.editing = true;
            this.elements = [...document.getElementsByClassName(this.selectorClass)];
            this.elements.forEach((checkbox) => {
                checkbox.style.display = 'inline-block';
            });
        },
        hideSelectors() {
            this.editing = false;
            this.elements.forEach((checkbox) => {
                checkbox.style.display = 'none';
            });
        },
        selectAll() {
            this.elements.forEach((checkbox) => {
                checkbox.checked = true;
            });
            this.allSelected = true;
        },
        deselectAll() {
            this.elements.forEach((checkbox) => {
                checkbox.checked = false;
            });
            this.allSelected = false;
        },
        getSelectedIds() {
            return this.elements.filter((checkbox) => checkbox.checked).map((checkbox) => Number.parseInt(checkbox.value));
        },
        deleteSelected() {
            const selectedIds = this.getSelectedIds();
            this.showConfirmation = false;
            axios.delete(this.deletePath, {
                data: {
                    ids: selectedIds,
                },
            }).then(() => {
                // reload the page to reflect changes but strip query parameter "page" for pagination
                const url = new URL(window.location.href);
                url.searchParams.delete('page');
                window.location.href = url.toString();
            }).catch((error) => {
                console.error('Error deleting images', error);
            });
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
